import General from './General/General';
import StoreStocks from './StoreStocks/StoreStocks';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';

import { cleanStockDetails, getStock } from 'redux/slices/Stocks';
import { RootState } from 'redux/store';
import { getSuppliers } from 'redux/slices/Suppliers';
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import Title from 'components/Title';
import { OldGeneral } from 'pages/stocks/ManagedProtable/General';
import { getFeatureFlagValue } from 'components/ZFeatureFlag';

export function NewStocks() {
	let { stockId } = useParams();
	const dispatch = useAppDispatch();
	const [isNewStock, setIsNewStock] = useState<boolean>(true);
	const user = useAppSelector((state: RootState) => state.logedinUser);
	const global = useAppSelector((state: RootState) => state.global);

    useEffect(() => {
		dispatch(getSuppliers());
    }, []);

	useEffect(() => {
		if (typeof stockId !== 'undefined' && !Number.isNaN(parseInt(stockId || ''))) {
			setIsNewStock(false);
			dispatch(getStock(stockId)).then((result) => {
				//Enable again once we need dispense pricing to be shown to the user
				//dispatch(getDispensePricing(result.payload[0].stockId));
			});
		} else {
			dispatch(cleanStockDetails());
		}
	}, [stockId]);

	return (
		<div className="stocks-page">
			<Title pageTitle={isNewStock ? "New Stock" : "Update Stock"} crumbs={[{name: "Managed Stocks", path: "/app/managed"}]} />
			<Tab.Container defaultActiveKey="1">
				<Row className='row-no-gutters'>
					<Col xs={12} style={{ padding: 0 }}>
						<Card>
							<Card.Body>
								<Row className="mb-2">
									<Nav id="stocks-nav" as="ul" variant="pills" className="nav nav-pills bg-nav-pills nav-justified mb-3">
										<Nav.Item as="li" className="nav-item">
											<Nav.Link href="#" eventKey="1" className="nav-link rounded-0">General</Nav.Link>
										</Nav.Item>
										<Nav.Item as="li" hidden={isNewStock || !user.permissions.functions.canView}>
											<Nav.Link href="#" eventKey="2" className="nav-link rounded-0">Store Stocks</Nav.Link>
										</Nav.Item>
										{/* <Nav.Item as="li" hidden={isNewStock}>
											<Nav.Link href="#" eventKey="3" className="nav-link rounded-0">Dispense Pricing</Nav.Link>
										</Nav.Item> */}
									</Nav>
									<Row style={{margin: '0px', padding: '0px'}}>
										<Col lg={12} style={{padding:'0px 3px'}}>
											{/* <Tabs 
												className="ag-grid-tabs-container m-1"
												defaultActiveKey="general"
											>
												<Tab title="General" eventKey="general" className="p-2">
													<General />
												</Tab>
												<Tab title="Store Stocks" eventKey="store-stocks" className="p-2" hidden={isNewStock || !user.permissions.functions.canView}>
													<StoreStocks />
												</Tab>
											</Tabs> */}
											<Tab.Content>
												<Tab.Pane eventKey="1">
													{getFeatureFlagValue(global.featureFlags, "ZFreedom.ManagedStock.AgGrid") === true ? (<General />) : (<OldGeneral />)}
												</Tab.Pane>
												<Tab.Pane eventKey="2" hidden={isNewStock || !user.permissions.functions.canView}>
													<StoreStocks />
												</Tab.Pane>
												{/* <Tab.Pane eventKey="3" hidden={isNewStock}>
													<DispensePricing />
												</Tab.Pane> */}
											</Tab.Content>
										</Col>
									</Row>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Tab.Container>
		</div>
	);
}